import { TagTestIdFactory } from '../../../Tag/interactions';
export const ComboboxTestIdFactory = {
    // bases, can be used for regex selecting in playwright
    getComboboxBase: () => 'combobox',
    getComboboxContainerBase: () => [ComboboxTestIdFactory.getComboboxBase(), 'container'].join('-'),
    getComboboxInputBase: () => [ComboboxTestIdFactory.getComboboxBase(), 'input'].join('-'),
    getComboboxToggleBase: () => [ComboboxTestIdFactory.getComboboxBase(), 'toggle'].join('-'),
    getComboboxValuesContainerBase: () => [ComboboxTestIdFactory.getComboboxBase(), 'values-container'].join('-'),
    getComboboxOptionBase: () => [ComboboxTestIdFactory.getComboboxBase(), 'option'].join('-'),
    getComboboxOptionTextBase: () => [ComboboxTestIdFactory.getComboboxOptionBase(), 'text'].join('-'),
    getComboboxOptionAvatarBase: () => [ComboboxTestIdFactory.getComboboxOptionBase(), 'avatar'].join('-'),
    getComboboxListboxBase: () => [ComboboxTestIdFactory.getComboboxBase(), 'listbox'].join('-'),
    getComboboxListBase: () => [ComboboxTestIdFactory.getComboboxBase(), 'list'].join('-'),
    getComboboxLabelBase: () => [ComboboxTestIdFactory.getComboboxBase(), 'label'].join('-'),
    getComboboxDescriptionBase: () => [ComboboxTestIdFactory.getComboboxBase(), 'description'].join('-'),
    getComboboxTagListBase: () => [ComboboxTestIdFactory.getComboboxBase(), 'tag-list'].join('-'),
    getComboboxGroupLabelBase: () => [ComboboxTestIdFactory.getComboboxBase(), 'group-label'].join('-'),
    // for test id generation
    getComboboxContainerTestId: (testId) => [ComboboxTestIdFactory.getComboboxContainerBase(), testId].join('-'),
    getComboboxLabelTestId: (testId) => [ComboboxTestIdFactory.getComboboxLabelBase(), testId].join('-'),
    getComboboxDescriptionTestId: (testId) => [ComboboxTestIdFactory.getComboboxDescriptionBase(), testId].join('-'),
    getComboboxToggleTestId: (testId) => [ComboboxTestIdFactory.getComboboxToggleBase(), testId].join('-'),
    getComboboxValuesContainerTestId: (testId) => [ComboboxTestIdFactory.getComboboxValuesContainerBase(), testId].join('-'),
    getComboboxInputTestId: (testId) => [ComboboxTestIdFactory.getComboboxInputBase(), testId].join('-'),
    getComboboxTagListOl: (testId) => [ComboboxTestIdFactory.getComboboxTagListBase(), testId].join('-'),
    getComboboxOptionTestId: (testId, optionId) => [ComboboxTestIdFactory.getComboboxOptionBase(), testId, optionId].join('-'),
    getComboboxOptionCheckboxTestId: (testId, optionDomId) => [testId, optionDomId].join('-'),
    getComboboxOptionTextTestId: (testId, optionId) => [
        ComboboxTestIdFactory.getComboboxOptionTextBase(),
        testId,
        optionId,
    ].join('-'),
    getComboboxOptionAvatarTestId: (testId, optionId) => [
        ComboboxTestIdFactory.getComboboxOptionAvatarBase(),
        testId,
        optionId,
    ].join('-'),
    getComboboxGroupLabelTestId: (testId, groupIndex) => [
        ComboboxTestIdFactory.getComboboxGroupLabelBase(),
        testId,
        String(groupIndex),
    ].join('-'),
    getComboboxListboxTestId: (testId) => [ComboboxTestIdFactory.getComboboxListboxBase(), testId].join('-'),
    getComboboxTagTestId: (testId, optionId) => [
        TagTestIdFactory.getTagTestId(ComboboxTestIdFactory.internalGenerateTagLiTestId(testId, optionId)),
    ].join('-'),
    getComboboxTagButtonTestId: (testId, optionId) => [
        TagTestIdFactory.getTagCloseButtonTestId(ComboboxTestIdFactory.internalGenerateTagLiTestId(testId, optionId)),
    ].join('-'),
    // internal, don't use outside of component
    internalGenerateTagLiTestId: (testId, optionId) => [testId, optionId].join('-'),
};
